﻿import { store } from '@redux/store';
import uiStateSlice from 'layout/redux/uiStateSlice';
import BasicLeadTrackingEvents from '../analytics/basicLeadTrackingEvent';
import BrochureTrackingEvents from '../analytics/brochureTrackingEvent';
import InformationTrackingEvents from '../analytics/informationTracking';
import TourTrackingEvents from '../analytics/tourTrackingEvent';
import AskQuestionTrackingEvents from '../analytics/askQuestionTrackingEvent';

/**
 * Gets the current state of the modalInformation object, and dispatch an action to update the modalInformation
 * object to reflect the lead generator flow.
 *
 * @returns The initial value from modalInformation object.
 */
export const initialState = (properties, getGoogleAnalyticsDTOCallback) => {
  const modalInformation = store.getState().uiState.modalInformation;
  const { listingInformation } = properties;
  const googleAnalyticsDTO = getGoogleAnalyticsDTOCallback ? getGoogleAnalyticsDTOCallback(listingInformation) : '';
  const newState = {
    id: modalInformation.id,
    type: modalInformation.type,
    name: 'leadGenerator',
    ...properties,
    googleAnalyticsDTO,
  };

  store.dispatch(uiStateSlice.actions.modalInformation(newState));

  return modalInformation;
};

export const postRecommendedLeadForm = (leadInformation) => {
  store.dispatch(
    uiStateSlice.actions.fetchModal({
      isFetchingModal: true,
      parameters: leadInformation,
    })
  );
};

export const postLeadBrochureForm = (leadInformation) => {
  const eventTracking = new BrochureTrackingEvents(Object.assign({}, leadInformation));
  const googleAnalyticsDTO =  eventTracking.events.googleAnalytics.map((event) => event.getGoogleAnalyticsData());
  store.dispatch(
    uiStateSlice.actions.fetchModal({
      isFetchingModal: true,
      parameters: leadInformation,
      googleAnalyticsDTO,
    })
  );
};

export const postLeadInformationForm = (leadInformation) => {
  const eventTracking = new InformationTrackingEvents(Object.assign({}, leadInformation));
  const googleAnalyticsDTO =  eventTracking.events.googleAnalytics.map((event) => event.getGoogleAnalyticsData());
  store.dispatch(
    uiStateSlice.actions.fetchModal({
      isFetchingModal: true,
      parameters: leadInformation,
      googleAnalyticsDTO,
    })
  );
};

export const postLeadTourForm = (leadInformation) => {
  const eventTracking = new TourTrackingEvents(Object.assign({}, leadInformation));
  const googleAnalyticsDTO =  eventTracking.events.googleAnalytics.map((event) => event.getGoogleAnalyticsData());
  store.dispatch(
    uiStateSlice.actions.fetchModal({
      isFetchingModal: true,
      parameters: leadInformation,
      googleAnalyticsDTO,
    })
  );
};

export const postLeadInformationFormBasic = (leadInformation) => {
  const eventTracking = new BasicLeadTrackingEvents(Object.assign({}, leadInformation));
  const googleAnalyticsDTO =  eventTracking.events.googleAnalytics.map((event) => event.getGoogleAnalyticsData());
  store.dispatch(
    uiStateSlice.actions.fetchModal({
      isFetchingModal: true,
      parameters: leadInformation,
      googleAnalyticsDTO,
    })
  );
};


export const postLeadAskQuestionForm = (leadInformation) => {
  const eventTracking = new AskQuestionTrackingEvents(Object.assign({}, leadInformation));
  const googleAnalyticsDTO =  eventTracking.events.googleAnalytics.map((event) => event.getGoogleAnalyticsData());
  store.dispatch(
    uiStateSlice.actions.fetchModal({
      isFetchingModal: true,
      parameters: leadInformation,
      googleAnalyticsDTO,
    })
  );
};

/**
 * This function takes in a modalInformation object and dispatches it to the reducer.
 * @param modalInformation - object with the id, type, and name to identify the modal.
 */
export const updateModalProgress = (modalInformation) => {
  store.dispatch(uiStateSlice.actions.modalInformation(modalInformation));
};
